import { GridColumnProps } from '@progress/kendo-react-grid'
import { SubscriptionPlatformKey } from 'api/Trading-Accounts/Types/SubscriptionDetailsDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const subscriptionPlatformColumns: GridColumn[] = [
  {
    title: 'Platform',
    field: SubscriptionPlatformKey.platform,
    show: true,
    filter: 'text',
  },
  {
    title: 'Tickmill Company',
    field: SubscriptionPlatformKey.company,
    show: true,
    filter: 'text',
  },
]
